/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd. <legal@vecros.com>
 * Proprietary and confidential.
 **********************************************************************************/

/**
 * Shared shapes for the AI Assistant (JSDoc — no runtime cost).
 *
 * @typedef {"user"|"assistant"} Role
 *
 * @typedef {Object} AgentStep
 * @property {string} label
 * @property {"running"|"done"|"failed"} status
 *
 * @typedef {Object} Message
 * @property {string} id
 * @property {Role} role
 * @property {string} content
 * @property {AgentStep[]=} steps
 * @property {"up"|"down"|null=} rating
 * @property {{code:string,message:string}=} error
 * @property {number} createdAt
 * @property {boolean=} streaming
 *
 * @typedef {Object} StreamEvent
 * @property {"chat"|"step"|"token"|"title"|"done"|"error"|"action"} type
 * @property {string=} assistantChatId
 * @property {string=} label
 * @property {"running"|"done"|"failed"=} status
 * @property {string=} text
 * @property {string=} title
 * @property {string=} messageId
 * @property {string=} code
 * @property {string=} message
 */

/** LLM providers the backend can route to (Option B — provider abstraction). */
export const PROVIDERS = {
  VECROS: "vecros", // default: our key, our backend
  ANTHROPIC: "anthropic", // BYOK (Claude)
  OPENAI: "openai", // BYOK (ChatGPT)
  GOOGLE: "google", // BYOK (Gemini)
};

/**
 * `keyUrl` deep-links to the provider's API-key console; `placeholder` hints the format.
 * @type {Record<string,{label:string,byok:boolean,keyUrl?:string,placeholder?:string}>}
 */
export const PROVIDER_META = {
  [PROVIDERS.VECROS]: { label: "Vecros (default)", byok: false },
  [PROVIDERS.ANTHROPIC]: {
    label: "Claude — your key",
    byok: true,
    keyUrl: "https://console.anthropic.com/settings/keys",
    placeholder: "sk-ant-…",
  },
  [PROVIDERS.OPENAI]: {
    label: "ChatGPT — your key",
    byok: true,
    keyUrl: "https://platform.openai.com/api-keys",
    placeholder: "sk-…",
  },
  [PROVIDERS.GOOGLE]: {
    label: "Gemini — your key",
    byok: true,
    keyUrl: "https://aistudio.google.com/apikey",
    placeholder: "AIza…",
  },
};

export {};
